import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

// Your web app's Firebase configuration
// original
// const firebaseOldConfig = {
//   apiKey: "AIzaSyBiM5psn5ppwKNFhziiEjV-bUyUI2itVlk",
//   authDomain: "formi-b96a7.firebaseapp.com",
//   databaseURL: "https://formi-b96a7.firebaseio.com",
//   projectId: "formi-b96a7",
//   storageBucket: "formi-b96a7.appspot.com",
//   messagingSenderId: "980055826627",
//   appId: "1:980055826627:web:67876da4bcd8864d550276",
// };

// // new
// const firebaseD2Config = {
//   apiKey: "AIzaSyAIyEa_n5dzCqTpa6k7felqDUH_Tqb4-Bg",
//   authDomain: "formi-surveys.firebaseapp.com",
//   databaseURL: "https://formi-surveys.firebaseio.com",
//   projectId: "formi-surveys",
//   storageBucket: "formi-surveys.appspot.com",
//   messagingSenderId: "716797844728",
//   appId: "1:716797844728:web:64fb367c0c830bf8a52f0d",
// };

// // day 3
// const firebaseD3Config = {
//   apiKey: "AIzaSyBCaJ1vM6S9X2U2WRgjAQ_ZoY6FD2pFrm4",
//   authDomain: "formi-day-3.firebaseapp.com",
//   databaseURL: "https://formi-day-3.firebaseio.com",
//   projectId: "formi-day-3",
//   storageBucket: "formi-day-3.appspot.com",
//   messagingSenderId: "664332970034",
//   appId: "1:664332970034:web:e7f39146fa7e2dec41b42b",
// };
// Initialize Firebase
// const app = initializeApp(firebaseConfig);

// const app2 = initializeApp(firebaseD2Config, "app2");

// const prevApp = initializeApp(firebaseOldConfig, "old");
// const db2 = getFirestore(app2);
// const dbOld = getFirestore(prevApp);
const firebaseConfig = {
  apiKey: "AIzaSyCfItvJ11A5byozwatYsAWu-e07H6Ui6aE",
  authDomain: "formi-launch.firebaseapp.com",
  databaseURL: "https://formi-launch.firebaseio.com",
  projectId: "formi-launch",
  storageBucket: "formi-launch.appspot.com",
  messagingSenderId: "683465595739",
  appId: "1:683465595739:web:db57dbaff8773a63fc587e",
};

const app = initializeApp(firebaseConfig);

const db = getFirestore(app);

export { db };
